/**
 * Resource endpoints
 */
export default {
    LOCATIONS: 'v1/locations',
};
